import type { DeviceKind } from "@gooner/shared";

/**
 * The fallback emoji for a device kind, used until the user picks their own.
 * Unicode has no tablet glyph, so a tablet borrows the laptop.
 *
 * This lives on its own rather than inside an icon component because a device kind is
 * not a monitor: it survives the cave deletion, and the device list needs the table
 * without needing the component that used to hold it.
 */
export const DEVICE_EMOJI: Record<DeviceKind, string> = {
  monitor: "🖥️",
  phone: "📱",
  tablet: "💻",
  other: "🖥️",
};

export function deviceEmoji(kind: DeviceKind): string {
  return DEVICE_EMOJI[kind];
}
